import { Component, Input } from '@angular/core';

@Component({
  selector: 'cut-tab',
  template: require('./tab.component.html'),
  styles: [
    require('./tabs.component.scss')
  ],
})
export class TabComponent {

  @Input()
  public id: string;

  @Input()
  public title: string;

  @Input()
  public selected: boolean;

}
